<template>
  <div class="jx-pg-attachments">
    <div
      v-for="(item, index) in attachments"
      :key="item.xmfjId || `${item.fjlx}-${index}`"
      class="jx-pg-attachments__row"
    >
      <el-select
        v-if="!readOnly"
        v-model="item.fjlx"
        class="jx-pg-attachments__type"
        placeholder="附件类型"
        @change="emitValue"
      >
        <el-option
          v-for="type in types"
          :key="type.value"
          :label="type.label"
          :value="type.value"
        />
      </el-select>
      <span
        v-else
        class="jx-pg-attachments__type-text"
      >
        {{ typeName(item.fjlx) }}
      </span>
      <span class="jx-pg-attachments__name">{{ item.wjmc || '尚未选择文件' }}</span>
      <file-serve-upload
        v-if="!readOnly"
        v-model="item._file"
        class="u-inline-block"
        :file-api="$config.ctx.hmfileApi"
        :data="uploadData"
        :before-upload="file => captureFile(item, file)"
        @input="syncFile(item, $event)"
      >
        <k-button
          btn-text="选择文件"
          :auth-type="false"
          type="primary"
          plain
          icon="kestrel-icon ki-cloud-upload"
        />
      </file-serve-upload>
      <k-button
        v-if="item.wjId"
        :btn-text="canPreview(item) ? '预览' : '下载'"
        :auth-type="false"
        type="primary"
        plain
        @click="openAttachment(item)"
      />
      <k-button
        v-if="!readOnly"
        btn-text="移除"
        :auth-type="false"
        type="danger"
        plain
        @click="remove(index)"
      />
    </div>
    <span v-if="readOnly && !attachments.length">-</span>
    <k-button
      v-if="!readOnly"
      btn-text="添加附件"
      :auth-type="false"
      icon="kestrel-icon ki-plus"
      plain
      @click="add"
    />
  </div>
</template>

<script>
export default {
  name: 'JxPgAttachmentEditor',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    },
    businessType: {
      type: String,
      default: 'jxxfpg'
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      attachments: [],
      uploadData: { meta: [{ key: 'type', value: this.businessType }] }
    };
  },
  methods: {
    add () {
      this.attachments.push({
        fjlx: this.types.length === 1 ? this.types[0].value : '',
        wjId: '',
        wjmc: '',
        dyxh: this.attachments.length + 1,
        _file: null,
        _pendingWjmc: '',
        _pendingWjdx: null
      });
      this.emitValue();
    },
    remove (index) {
      this.attachments.splice(index, 1);
      this.emitValue();
    },
    syncFile (item, value) {
      const file = Array.isArray(value) ? value[0] : value;
      if (file && typeof file === 'object') {
        item.wjId = file.id || file.fileId || file.wjId || '';
        item.wjmc = file.name || file.fileName || file.wjmc || item._pendingWjmc || '';
        item.wjzy = file.sha256 || file.wjzy || '';
        item.wjdx = file.size || file.wjdx || item._pendingWjdx || null;
      } else if (file) {
        item.wjId = file;
        item.wjmc = item._pendingWjmc || item.wjmc;
        item.wjdx = item._pendingWjdx || item.wjdx;
      }
      item._pendingWjmc = '';
      item._pendingWjdx = null;
      this.emitValue();
    },
    captureFile (item, file) {
      item._pendingWjmc = file.name;
      item._pendingWjdx = file.size;
      return true;
    },
    typeName (value) {
      const type = this.types.find(item => item.value === value);
      return type ? type.label : value || '附件';
    },
    canPreview (item) {
      return /\.(pdf|png|jpe?g|gif|bmp|webp)$/i.test(item.wjmc || '');
    },
    previewMime (item) {
      const extension = ((item.wjmc || '').match(/\.([^.]+)$/) || [])[1];
      return {
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        bmp: 'image/bmp',
        webp: 'image/webp'
      }[(extension || '').toLowerCase()];
    },
    openAttachment (item) {
      this.$axios.get(`${this.$config.fileApi.initDownload}/${item.wjId}`).then(rsp => {
        const path = rsp.data.data;
        return this.$axios.get(`${this.$config.fileApi.download}/${path}`, { responseType: 'blob' });
      }).then(rsp => {
        if (!this.canPreview(item)) {
          this.$HMUtil.downloadStreamFile(rsp.data, item.wjmc);
          return;
        }
        const blob = new Blob([rsp.data], { type: this.previewMime(item) });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      });
    },
    emitValue () {
      this.$emit('input', this.attachments.map((item, index) => ({
        xmfjId: item.xmfjId,
        fjlx: item.fjlx,
        wjId: item.wjId,
        wjmc: item.wjmc,
        wjzy: item.wjzy,
        wjdx: item.wjdx,
        dyxh: index + 1
      })));
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value !== this.attachments) {
          this.attachments = (value || []).map(item => Object.assign({
            _file: null,
            _pendingWjmc: '',
            _pendingWjdx: null
          }, item));
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.jx-pg-attachments__row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  margin-bottom: 8px;
}

.jx-pg-attachments__type {
  width: 180px;
}

.jx-pg-attachments__type-text {
  width: 180px;
  color: #606266;
}

.jx-pg-attachments__name {
  flex: 1;
  min-width: 180px;
  color: #606266;
}
</style>
